import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Campaign } from '@datapad/data-model';
import { Box, Button, TextField, Typography } from '@mui/material';
import React from 'react';
export function CampaignCreationForm(props) {
    const { cancel, submit } = props;
    const [name, setName] = React.useState('');
    const nameError = name.trim().length === 0;
    const canSubmit = !nameError;
    const handleSubmit = () => {
        if (!canSubmit)
            return;
        const campaign = new Campaign({
            name: name.trim(),
            activeCharacters: [],
            inactiveCharacters: [],
        });
        submit(campaign);
    };
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            p: 2,
            minWidth: 400,
        }, children: [_jsx(Typography, { variant: "h6", children: "Create New Campaign" }), _jsx(TextField, { label: "Campaign Name", value: name, onChange: (e) => setName(e.target.value), error: nameError && name.length > 0, helperText: nameError && name.length > 0 ? 'Campaign name is required' : undefined, required: true, fullWidth: true, size: "small", autoFocus: true }), _jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', pt: 1 }, children: [_jsx(Button, { variant: "contained", color: "primary", onClick: handleSubmit, disabled: !canSubmit, children: "Create" }), _jsx(Button, { variant: "outlined", color: "secondary", onClick: cancel, children: "Cancel" })] })] }));
}
//# sourceMappingURL=CampaignCreationForm.js.map